import MobileDetect from 'mobile-detect';
import detectHover from 'detect-hover';

class Device {
    constructor() {
        const md = new MobileDetect(window.navigator.userAgent);
        this.isTouch = (md.mobile() !== null) && !detectHover.anyHover;
    }
}

const instance = new Device();
export default instance;
